document.addEventListener("DOMContentLoaded", () => {
  const card = document.querySelector(
    ".shopify-section--home-category-gateway .category-gateway-card:first-child"
  );

  if (!card) return;

  function updatePointer(event) {
    const rect = card.getBoundingClientRect();
    card.style.setProperty("--fgg-x", `${event.clientX - rect.left}px`);
    card.style.setProperty("--fgg-y", `${event.clientY - rect.top}px`);
  }

  card.addEventListener("pointerenter", (event) => {
    updatePointer(event);
    card.classList.add("fgg-mouse-active");
  });

  card.addEventListener("pointermove", updatePointer);

  card.addEventListener("pointerleave", () => {
    card.classList.remove("fgg-mouse-active");
  });
});